// extracted by mini-css-extract-plugin
module.exports = {"flag":"LanguagePicker-module__flag___CjeV2"};